import React, { useState } from 'react';
import GameBoard from '../components/memory-game/GameBoard';
import Button from '../components/common/Button';
import NavigationRanking from '../components/NavigationRanking';
import Leaderboard from '../components/Leaderboard';
import { useMemoryLeaderboard } from '../hooks/useLeaderboard';
import { LeaderboardType } from '../types';

export type Difficulty = 'easy' | 'medium' | 'hard';

const difficultySettings = {
  easy: { pairs: 4 },
  medium: { pairs: 6 },
  hard: { pairs: 8 },
};

const MemoryMatchPage: React.FC = () => {
  const [difficulty, setDifficulty] = useState<Difficulty | null>(null);
  const [activeTab, setActiveTab] = useState<LeaderboardType>('weekly');

  const { users: weeklyUsers, loading: weeklyLoading, error: weeklyError } = useMemoryLeaderboard('weekly');
  const { users: monthlyUsers, loading: monthlyLoading, error: monthlyError } = useMemoryLeaderboard('monthly');
  const { users: allTimeUsers, loading: allTimeLoading, error: allTimeError } = useMemoryLeaderboard('allTime');

  const handleDifficultySelect = (level: Difficulty) => {
    setDifficulty(level);
  };

  if (!difficulty) {
    return (
      <div className="container mx-auto px-4 py-8 flex flex-col items-center">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
          Jogo da Memória
        </h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">Selecione a Dificuldade</h2>
        <div className="flex space-x-4">
          <Button onClick={() => handleDifficultySelect('easy')} size="lg" className="bg-green-500 hover:bg-green-600 text-white">
            Fácil
          </Button>
          <Button onClick={() => handleDifficultySelect('medium')} size="lg" className="bg-yellow-500 hover:bg-yellow-600 text-white">
            Médio
          </Button>
          <Button onClick={() => handleDifficultySelect('hard')} size="lg" className="bg-red-500 hover:bg-red-600 text-white">
            Difícil
          </Button>
        </div>

        <div className="mt-12">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Ranking</h2>
        <div className="max-w-2xl mx-auto">
          <NavigationRanking activeTab={activeTab} onTabChange={setActiveTab} />
          <div className="bg-slate-900/80 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-slate-200">
            {activeTab === 'weekly' && (
              <Leaderboard
                title="Weekly Rankings"
                type="weekly"
                users={weeklyUsers}
                loading={weeklyLoading}
                error={weeklyError}
              />
            )}
            {activeTab === 'monthly' && (
              <Leaderboard
                title="Monthly Rankings"
                type="monthly"
                users={monthlyUsers}
                loading={monthlyLoading}
                error={monthlyError}
              />
            )}
            {activeTab === 'allTime' && (
              <Leaderboard
                title="All-Time Rankings"
                type="allTime"
                users={allTimeUsers}
                loading={allTimeLoading}
                error={allTimeError}
              />
            )}
          </div>
        </div>
      </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        Jogo da Memória
      </h1>
      <GameBoard
        difficulty={difficulty}
        settings={difficultySettings[difficulty]}
        onBack={() => setDifficulty(null)}
      />

      <div className="mt-12">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Ranking</h2>
        <div className="max-w-2xl mx-auto">
          <NavigationRanking activeTab={activeTab} onTabChange={setActiveTab} />
          <div className="bg-slate-900/80 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-slate-200">
            {activeTab === 'weekly' && (
              <Leaderboard
                title="Weekly Rankings"
                type="weekly"
                users={weeklyUsers}
                loading={weeklyLoading}
                error={weeklyError}
              />
            )}
            {activeTab === 'monthly' && (
              <Leaderboard
                title="Monthly Rankings"
                type="monthly"
                users={monthlyUsers}
                loading={monthlyLoading}
                error={monthlyError}
              />
            )}
            {activeTab === 'allTime' && (
              <Leaderboard
                title="All-Time Rankings"
                type="allTime"
                users={allTimeUsers}
                loading={allTimeLoading}
                error={allTimeError}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemoryMatchPage;
